import React, { FC, useState } from 'react'

type Props = {
    fieldPropsTextbox: any
    fieldPropsRadio: any
    touched: any
    errors: any
    displayText: string
}

export const AncientRadioTextbox: React.FC<Props> = ({ displayText, fieldPropsTextbox, fieldPropsRadio, touched, errors }) => {

    return (
        <div className="mb-5">
            <label className="form-label">{displayText}</label>
            <div className="input-group">
                <div className="input-group-prepend">
                    <div className="input-group-text py-4">
                        <input
                            type="checkbox"
                            checked={fieldPropsRadio.value}
                            {...fieldPropsRadio}
                        />
                    </div>
                </div>
                <input type="text"
                    className="form-control"
                    {...fieldPropsTextbox}
                />
            </div>
            {touched && errors && (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{errors}</div>
                </div>
            )}
        </div>
    )
}
